import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const CircleError: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.1667C17.0626 21.1667 21.1667 17.0626 21.1667 12C21.1667 6.93739 17.0626 2.83333 12 2.83333C6.93739 2.83333 2.83333 6.93739 2.83333 12C2.83333 17.0626 6.93739 21.1667 12 21.1667ZM12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
    />
    <path d="M8.5 8.5L15.5 15.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8.5 15.5L15.5 8.5" stroke="currentColor" strokeWidth="1.5" />
  </SvgIcon>
)
